__turbopack_context__.v({
  "img": "Y5LSAW_img",
  "info": "Y5LSAW_info",
  "link": "Y5LSAW_link",
  "moveRight": "Y5LSAW_moveRight",
  "product": "Y5LSAW_product",
  "products": "Y5LSAW_products",
  "section": "Y5LSAW_section",
  "spec": "Y5LSAW_spec",
  "title": "Y5LSAW_title",
});
